import { Box, Grid, Typography } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';

export type FormSectionProps = {
    title?: ReactNode;
    rightAction?: ReactNode;
};

/**
 * @deprecated Now we use the `FormSection` component from ui-component/formComponents.
 */
export const FormSection = ({ title, rightAction, children }: PropsWithChildren<FormSectionProps>) => (
    <Box component="section" sx={{ mb: '12px', padding: '8px 24px', border: 'solid 1px #EBEEFE', borderRadius: '8px' }}>
        <Grid container alignItems="center" sx={{ mb: '5px' }}>
            <Grid item xs={9}>
                <Typography variant="h4" fontSize="20px" fontWeight={500} color="#37326E">
                    {title}
                </Typography>
            </Grid>
            {rightAction && (
                <Grid item xs={3}>
                    {rightAction}
                </Grid>
            )}
        </Grid>
        {children}
    </Box>
);
